export const createDimensionTooltipLine = (dimension, config) => ({ label: config?.label ?? "", value: dimension?.toString() ?? "" });
